import React, { FC } from 'react';

const ForbiddenPage: FC = () => {
    return <>403 Forbidden</>;
};

export default ForbiddenPage;
